import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import useToast from '../../../util/hooks/useToast';
import { useAppDispatch } from '../../../redux/hooks';

import Input from '../../../components/Input';
import Button from '../../../components/Button';
import ArrowRight from '../../../assets/svg_components/ArrowRight';
import { setEmail } from '../../../redux/slices/user/userSlice';
import ForgotPasswordVerifyScreen from '../ForgotPasswordVerifyScreen';
import AuthHeader from '../../../components/AuthBackground/_partials/AuthHeader';
// import { ReactComponent as EmailInputIcon } from '../../../assets/images/email-input-icon.svg';
import { emailValidation } from '../../../modal_views/auth/ForgotPasswordIdentityModal/ForgotPasswordIdentityModal.validation';
import { FORGOT_PASSWORD_BY_EMAIL } from '../../../graphql/queries';

import ForgotPassStyles from './ForgotPasswordScreen.module.scss';
import useCustomQuery from '../../../network/useCustomQuery';

const ForgotPassword = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [getForgotPasswordRealtor, forgotPasswordRealtorLoading, forgotPasswordRealtorData] =
    useCustomQuery({
      query: FORGOT_PASSWORD_BY_EMAIL,
      onError: () => {},
      onData: () => {}
    });
  const Toast = useToast();
  const [error, setError] = useState('');
  const [otpVerify, setOtpVerify] = useState(false);

  useEffect(() => {
    if (error) {
      Toast.error(error);

      setError('');
    }
  }, [error]);

  useEffect(() => {
    if (forgotPasswordRealtorData?.forgotPasswordRealtor?.status === 200) {
      setOtpVerify(true);
    } else {
      setError(forgotPasswordRealtorData?.forgotPasswordRealtor?.message);
    }
  }, [forgotPasswordRealtorData]);

  const resetByEmailFormik = useFormik({
    validationSchema: emailValidation,
    initialValues: {
      email: ''
    },
    onSubmit: async (values) => {
      const payload = {
        email: values.email
      };
      setError('');
      getForgotPasswordRealtor({ variables: payload });
      dispatch(setEmail(values.email));
    }
  });

  return (
    <div className={ForgotPassStyles.forgotPass}>
      <AuthHeader className={ForgotPassStyles.forgotPass__authHeader} />
      {!otpVerify && (
        <div className={ForgotPassStyles.forgotPass__content}>
          <h1 className={ForgotPassStyles.forgotPass__headText}>Forgot Your Password?</h1>
          <p className={ForgotPassStyles.forgotPass__subtext}>
            Please enter your registered information to reset your password
          </p>

          <form
            onSubmit={resetByEmailFormik.handleSubmit}
            className={ForgotPassStyles.forgotPass__form}>
            <div className={ForgotPassStyles.forgotPass__input}>
              <Input
                type="email"
                name="email"
                labelColor="rgba(93, 93, 93, 1)"
                label="Email address"
                placeholder="e.g. user@email.com"
                value={resetByEmailFormik.values.email}
                onChange={resetByEmailFormik.handleChange}
                error={resetByEmailFormik.submitCount > 0 && resetByEmailFormik.errors.email}
              />
            </div>

            <Button
              className={ForgotPassStyles.forgotPass__button}
              title="Verify email address"
              color="primary"
              type="submit"
              isLoading={forgotPasswordRealtorLoading}
              disabled={resetByEmailFormik.isSubmitting || forgotPasswordRealtorLoading}
            />
          </form>
          <div className={ForgotPassStyles.forgotPass__redirect}>
            <div className={ForgotPassStyles.forgotPass__redirectText}>
              <ArrowRight className={ForgotPassStyles.forgotPass__redirectArrow} stroke="#06080E" />
              <span
                className={ForgotPassStyles.forgotPass__redirectClickable}
                onClick={() => {
                  navigate('/');
                }}>
                Go back to login
              </span>
            </div>
          </div>
        </div>
      )}
      {otpVerify && <ForgotPasswordVerifyScreen />}
    </div>
  );
};

export default ForgotPassword;
